/**
 * SolutionsBuildersHero — the `/solutions/builders` design.
 *
 * Verbatim render of `solutions-builders.html`. Modules in
 * ./landing/solutions-builders/.
 */
import { STYLES } from "./landing/solutions-builders/styles";
import { MARKUP } from "./landing/solutions-builders/markup";
import { SCRIPT } from "./landing/solutions-builders/script";
import { PageHost } from "./landing/PageHost";

export function SolutionsBuildersHero() {
  return (
    <PageHost
      styles={STYLES}
      markup={MARKUP}
      script={SCRIPT}
      hostClass="trex-builders-host"
      wireLinks={true}
      data-testid="solutions-builders-hero"
    />
  );
}
